module.exports = __webpack_public_path__ + "static/media/p2ru.48561e31.pdf";